import { App, View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout } from "@pimo/pimo-components/src/lib/layouts/drag-and-drop-layout/drag-and-drop-layout";
import { PMDescriptionCard } from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { TestAppState } from "../../../app";
import { getOverviewCardCopy } from "../get-card-copy";

export function addProgramDescriptionAndManagementSummaryCards(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
): void {
  const { getCardCopy } = getOverviewCardCopy(app);

  const programDescriptionComponent = view.addComponent({
    component: PMDescriptionCard,
    layoutProps: {
      componentId: "programDescriptionComponent",
      title: "",
      description: "",
      labels: ["Program", "Description"],
    },
  });

  programDescriptionComponent.mapLayoutProps(({ language }) => ({
    componentId: "programDescriptionComponent",
    labels: ["Program", "Description"],
    title: getLocalizedMessage(
      language || "en",
      "reportingStructure.programDescription"
    ),
    description: getLocalizedMessage(
      language || "en",
      "showsProgramDescription"
    ),
  }));

  programDescriptionComponent.mapState(({ settings }) => ({
    text: settings?.configuration?.programDescription ?? "",
  }));

  const managementSummaryComponent = view.addComponent({
    component: PMDescriptionCard,
    layoutProps: {
      componentId: "managementSummaryComponent",
      title: "",
      description: "",
      labels: ["managementSummary"],
    },
  });

  managementSummaryComponent.mapLayoutProps(({ language }) => ({
    componentId: "managementSummaryComponent",
    labels: ["managementSummary"],
    description: getCardCopy(language, "managementSummary").description,
    title: getCardCopy(language, "managementSummary").title,
  }));

  managementSummaryComponent.mapState(({ dashboard, language }) => {
    return {
      title: getCardCopy(language, "managementSummary").title,
      description: dashboard?.managementSummary || "",
      text: dashboard?.managementSummary || "",
    };
  });
}
